export const resolveCardWithReceiptURL = (fileName: string) => {
  return `${process.env.REACT_APP_ADMIN_DOMAIN}cards/receiptPhoto/${fileName}`;
};
